import React from 'react'

export default () => (
  <div>
    <div className="game-title">
      <h3 className="game-title__text">wordreverse</h3>
      <h3 className="game-title__text game-title__reverse-1">wordreverse</h3>
    </div>
    <div className="game-title">
      <h3 className="game-title__text game-title__reverse-2">wordreverse</h3>
      <h3 className="game-title__text game-title__reverse-3">wordreverse</h3>
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/GamePageTitle.js